module.exports = __webpack_public_path__ + "static/media/thumb.e8cde54f.webp";